<template>
  <v-window v-model="tab">
    <v-window-item>
      <RoleList ref="tab0" :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <RoleDetail ref="tab1" :open-tab="openTab" :item="item"/>
    </v-window-item>
    <v-window-item>
      <RoleCreateOrUpdate ref="tab2" :open-tab="openTab" :item="item"/>
    </v-window-item>
  </v-window>
</template>

<script>
import RoleList from './RoleList.vue'
import RoleDetail from './RoleDetail.vue'
import RoleCreateOrUpdate from './CreateOrUpdate.vue'
import mixin from '../../mixin'

export default {
  name: 'RoleMain',
  mixins: [mixin],
  components: {
    RoleList,
    RoleDetail,
    RoleCreateOrUpdate
  },
  data() {
    return {
      item: null,
      tab: 0,
    }
  },
  methods: {
    openTab(tab, item) {
      this.tab = tab
      this.item = item
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(item)
    },
  },
}
</script>

<style scoped>
</style>